const sxStyles = ({ breakpoints, typography, spacing, palette, zIndex }) => ({
    appBar: {
        backgroundColor: palette.background.paper,
        color: palette.text.secondary,
        zIndex: zIndex.drawer,
        boxShadow: "none",
        borderBottom: `1px solid ${palette.grey[300]}`,
    },
    toolbar: {
        paddingLeft: `${spacing(2)} !important`,
        paddingRight: `calc(${spacing(2)} + 4px) !important`,
    },
    wrapper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },
    logo: {
        display: "flex",
        alignItems: "center",
        marginRight: "auto",
    },
    content: {
        display: "flex",
        justifyContent: "flex-end",
        marginLeft: "auto",
        alignItems: "center",
    },
    divider: {
        flex: 1,
        [breakpoints.down("md")]: {
            flex: 0,
        },
    },
    title: {
        justifyContent: "center",
        paddingLeft: 2,
        paddingRight: 2,
        display: "flex",
        whiteSpace: "nowrap",
        [breakpoints.down("md")]: {
            display: "block",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "calc(100vw - 200px)",
        },
    },
    avatar: {
        width: 4,
        height: 4,
        marginLeft: 1,
        fontSize: typography.caption.fontSize,
    },
});
export default sxStyles;
//# sourceMappingURL=Header.style.js.map